export default __webpack_public_path__ + "static/media/236.ee046e30.png";